import {
    validateName,
    validateAdvertiser,
    validateAgency,
    validateCategory,
    validateDeal,
    validateEndDate,
    validateStartDate,
    validatePoNumbers,
    validateBillingTerms,
    validateTaxRate
} from './CampaignBrief/CampaignBriefValidationService';
import { BusinessTypes } from '../../constants/Enums';

export const validateCampaign = async (campaign, campaignBriefOnly = false) => {
    if (!(await validateCampaignBrief(campaign))) {
        return false;
    }

    if (!campaignBriefOnly) {
        if (!(await validateStationSelection(campaign))) {
            return false;
        }

        if (!(await validateAutomationSettings(campaign))) {
            return false;
        }

        if (!(await validateAirtimePlanning(campaign))) {
            return false;
        }
    }
    // ToDo: add validation for remaining steps

    return true;
};

export const validCampaignObject = async (campaign) => {
    let validName = false;
    if (campaign) {
        await validateName(campaign.id, campaign.name, 0, false).then((results) => {
            validName = !results?.status?.statusMessage;
        });
    }
    const validAdvertiser = validateAdvertiser(campaign.advertiserAccountId, campaign.advertiserAccountName);
    const validAgency = validateAgency(campaign.agencyAccountId, campaign.agencyAccountName);
    const isAirtime = campaign.businessType.toLowerCase() === BusinessTypes.AIRTIME.name.toLowerCase();

    const isPackage = campaign.businessType.toLowerCase() === BusinessTypes.PACKAGE.name.toLowerCase();

    return {
        name: validName,
        startDate: validateStartDate(campaign?.startDate, campaign?.endDate),
        endDate: validateEndDate(campaign?.startDate, campaign?.endDate),
        advertiser: validAdvertiser || validAgency,
        agency: validAgency || validAdvertiser,
        deal: validateDeal(campaign?.dealVersionId, isAirtime),
        category: validateCategory(
            campaign.productCategoryId,
            campaign.productCategoryName,
            campaign.businessType.toLowerCase() === BusinessTypes.OFFAIRS.name.toLowerCase() ||
                campaign.businessType.toLowerCase() === BusinessTypes.DIGITAL.name.toLowerCase()
        ),
        billingTerms: validateBillingTerms(campaign?.billingTermId),
        taxRate: validateTaxRate(campaign?.vatId),
        poNumbersJson: () => true
    };
};

const validateCampaignBrief = async (campaign) => {
    let validBrief = true;
    // Best to validate specific scenarios in the dedicated function, having these consistent with the other checks avoids conditional logic in a loop
    const validationObject = await validCampaignObject(campaign);

    for (const field in validationObject) {
        if (!validationObject[field]) {
            validBrief = false;
            break;
        }
    }

    return validBrief;
};

const validateStationSelection = async (campaign) => {
    // validation goes here

    return true;
};

const validateAutomationSettings = async (campaign) => {
    // validation goes here

    return true;
};

const validateAirtimePlanning = async (campaign) => {
    // validation goes here

    return true;
};

export const showSaveBar = (businessType, currentStep, bespokeBilling) => {
    let retVal = true;
    let cStep;
    switch (businessType?.toLowerCase()) {
        case BusinessTypes.AIRTIME.name.toLowerCase():
            cStep = bespokeBilling && currentStep > 5 ? currentStep - 1 : currentStep;

            switch (cStep) {
                case 3: // airtime planning
                case 4: // off air costs
                case 5: // bespoke billing & quote and booking
                case 6: // transmission times
                case 7: // billing
                case 8: // performance
                    retVal = false;
                    break;
            }
            break;
        case BusinessTypes.AIRTIMEBURST.name.toLowerCase():
            switch (currentStep) {
                case 3: // airtime planning
                case 4: // off air costs
                case 5: // quote and booking
                case 6: // transmission times
                case 7: // billing
                case 8: // performance
                    retVal = false;
                    break;
            }
            break;
        case BusinessTypes.SANDP.name.toLowerCase():
            cStep = bespokeBilling && currentStep > 3 ? currentStep - 1 : currentStep;

            switch (cStep) {
                case 1: // property selection
                case 2: // off air costs
                case 3: // bespoke billing & quote and booking
                case 4: // transmission times
                case 5: // billing
                case 6: // performance
                    retVal = false;
                    break;
            }
            break;
        case BusinessTypes.OFFAIRS.name.toLowerCase():
            cStep = bespokeBilling && currentStep > 2 ? currentStep - 1 : currentStep;

            switch (cStep) {
                case 1: // off air costs
                case 2: // bespoke billing & quote and booking
                case 3: // transmission times
                case 4: // billing
                case 5: // performance
                    retVal = false;
                    break;
            }
            break;
        case BusinessTypes.DIGITAL.name.toLowerCase():
            cStep = bespokeBilling && currentStep > 2 ? currentStep - 1 : currentStep;

            switch (cStep) {
                case 1: // off air costs
                case 2: // bespoke billing & quote and booking
                case 3: // transmission times
                case 4: // billing
                case 5: // performance
                    retVal = false;
                    break;
            }
            break;
    }

    return retVal;
};

export const displayStep = (businessType, currentStep, stepName) => {
    if (!businessType) {
        return;
    }
    let retVal = false;

    switch (businessType.toLowerCase()) {
    // PACKAGE business type is no longer available
        case BusinessTypes.AIRTIMEBURST.name.toLowerCase():
            // This code gets harder and harder to fathom

            switch (currentStep) {
                case 1:
                    if (stepName === 'StationSelection') retVal = true;
                    break;
                case 2:
                    if (stepName === 'AutomationSettings') retVal = true;
                    break;
                case 3:
                    if (stepName === 'AirtimePlanning' || stepName === 'QuoteBooking') retVal = true;
                    break;
                case 4:
                    if (stepName === 'TransmissionTimes') retVal = true;
                    break;
            }
            break;
        case BusinessTypes.AIRTIME.name.toLowerCase():
            switch (currentStep) {
                case 1:
                    if (stepName === 'StationSelection') retVal = true;
                    break;
                case 2:
                    if (stepName === 'AutomationSettings') retVal = true;
                    break;
                case 3:
                    if (stepName === 'AirtimePlanning') retVal = true;
                    break;
                case 4:
                    if (stepName === 'OffAirCosts') retVal = true;
                    break;
                case 5:
                    if (stepName === 'BespokeBilling' || stepName === 'QuoteBooking') retVal = true;
                    break;
                case 6:
                    if (stepName === 'TransmissionTimes') retVal = true;
                    break;
                case 7:
                    if (stepName === 'Billing') retVal = true;
                    break;
                case 8:
                    if (stepName === 'Performance') retVal = true;
                    break;
            }
            break;
        case BusinessTypes.SANDP.name.toLowerCase():
            switch (currentStep) {
                case 1:
                    if (stepName === 'OffAirCosts') retVal = true;
                    break;
                case 2:
                    if (stepName === 'BespokeBilling' || stepName === 'QuoteBooking') retVal = true;
                    break;
                case 3:
                    if (stepName === 'AirtimeSettings') retVal = true;
                    break;
                case 4:
                    if (stepName === 'TransmissionTimes') retVal = true;
                    break;
                case 5:
                    if (stepName === 'Billing') retVal = true;
                    break;
                case 6:
                    if (stepName === 'Performance') retVal = true;
                    break;
            }
            break;
        case BusinessTypes.OFFAIRS.name.toLowerCase():
            switch (currentStep) {
                case 1:
                    if (stepName === 'OffAirCosts') retVal = true;
                    break;
                case 2:
                    if (stepName === 'BespokeBilling' || stepName === 'QuoteBooking') retVal = true;
                    break;
                // case 3:
                //     if (stepName === 'TransmissionTimes') retVal = true;
                //     break;
                // case 4:
                case 3:
                    if (stepName === 'Billing') retVal = true;
                    break;
                // case 5:
                //     if (stepName === 'Performance') retVal = true;
                //     break;
            }
            break;
        case BusinessTypes.DIGITAL.name.toLowerCase():
            switch (currentStep) {
                case 1:
                    if (stepName === 'OffAirCosts') retVal = true;
                    break;
                case 2:
                    if (stepName === 'BespokeBilling' || stepName === 'QuoteBooking') retVal = true;
                    break;
                // case 3:
                //     if (stepName === 'TransmissionTimes') retVal = true;
                //     break;
                // case 4:
                case 3:
                    if (stepName === 'Billing') retVal = true;
                    break;
                // case 5:
                //     if (stepName === 'Performance') retVal = true;
                //     break;
            }
            break;
    }

    return retVal;
};
